import { useNavigate } from 'react-router-dom'
import { useI18n } from '../i18n'
import { Meta } from '../components/Meta'

const QR_TYPES = ['Link', 'Text', 'WiFi', 'WhatsApp', 'vCard', 'Instagram']

function CheckIcon() {
  return (
    <svg className="h-4 w-4 text-primary shrink-0 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
    </svg>
  )
}

function CrossIcon() {
  return (
    <svg className="h-4 w-4 text-text-muted/50 shrink-0 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
    </svg>
  )
}

export function LandingPage() {
  const { t } = useI18n()
  const navigate = useNavigate()

  return (
    <>
      <Meta
        title={t('meta.landing.title')}
        description={t('meta.landing.description')}
        path="/"
      />

      <div className="mx-auto w-full max-w-4xl px-4 py-16 flex flex-col gap-20">

        {/* Hero */}
        <section className="text-center flex flex-col items-center gap-6">
          <h1 className="text-4xl font-bold text-text leading-tight sm:text-5xl">
            {t('landing.hero.title')}
          </h1>
          <p className="text-lg text-text-muted max-w-xl">
            {t('landing.hero.subtitle')}
          </p>
          <button
            onClick={() => navigate('/create')}
            className="rounded-xl bg-primary px-8 py-4 text-base font-semibold text-white transition-colors hover:bg-primary-dark"
          >
            {t('landing.hero.cta')}
          </button>
        </section>

        {/* Static vs Dynamic */}
        <section className="grid grid-cols-1 gap-6 sm:grid-cols-2">

          {/* Static */}
          <div className="rounded-xl bg-surface-light p-6 flex flex-col gap-4">
            <div>
              <span className="inline-block rounded-md bg-surface px-3 py-1 text-xs font-semibold uppercase tracking-wider text-text-muted mb-3">
                Static
              </span>
              <h2 className="text-xl font-bold text-text">{t('landing.static.title')}</h2>
              <p className="mt-2 text-sm text-text-muted leading-relaxed">
                {t('landing.static.desc')}
              </p>
            </div>
            <ul className="flex flex-col gap-2">
              <li className="flex items-start gap-2 text-sm text-text"><CheckIcon />{t('landing.static.feat1')}</li>
              <li className="flex items-start gap-2 text-sm text-text"><CheckIcon />{t('landing.static.feat2')}</li>
              <li className="flex items-start gap-2 text-sm text-text"><CheckIcon />{t('landing.static.feat3')}</li>
              <li className="flex items-start gap-2 text-sm text-text-muted"><CrossIcon />{t('landing.static.feat4')}</li>
            </ul>
            <button
              onClick={() => navigate('/create')}
              className="mt-auto rounded-lg border-2 border-primary px-4 py-2.5 text-sm font-semibold text-primary transition-colors hover:bg-primary/10"
            >
              {t('landing.hero.cta')}
            </button>
          </div>

          {/* Dynamic */}
          <div className="rounded-xl bg-primary/10 border-2 border-primary/30 p-6 flex flex-col gap-4">
            <div>
              <span className="inline-block rounded-md bg-primary/20 px-3 py-1 text-xs font-semibold uppercase tracking-wider text-primary mb-3">
                Dynamic
              </span>
              <h2 className="text-xl font-bold text-text">{t('landing.dynamic.title')}</h2>
              <p className="mt-2 text-sm text-text-muted leading-relaxed">
                {t('landing.dynamic.desc')}
              </p>
            </div>
            <ul className="flex flex-col gap-2">
              <li className="flex items-start gap-2 text-sm text-text"><CheckIcon />{t('landing.dynamic.feat1')}</li>
              <li className="flex items-start gap-2 text-sm text-text"><CheckIcon />{t('landing.dynamic.feat2')}</li>
              <li className="flex items-start gap-2 text-sm text-text"><CheckIcon />{t('landing.dynamic.feat3')}</li>
              <li className="flex items-start gap-2 text-sm text-text-muted"><CrossIcon />{t('landing.dynamic.feat4')}</li>
            </ul>
            <button
              onClick={() => navigate('/register')}
              className="mt-auto rounded-lg bg-primary px-4 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-primary-dark"
            >
              {t('landing.dynamic.cta')}
            </button>
          </div>
        </section>

        {/* QR Types */}
        <section className="text-center flex flex-col items-center gap-6">
          <div>
            <h2 className="text-2xl font-bold text-text">{t('landing.types.title')}</h2>
            <p className="mt-2 text-sm text-text-muted">{t('landing.types.subtitle')}</p>
          </div>
          <div className="flex flex-wrap justify-center gap-2">
            {QR_TYPES.map((type) => (
              <span
                key={type}
                className="rounded-lg border-2 border-surface-lighter bg-surface px-4 py-2 text-sm font-medium text-text-muted"
              >
                {type}
              </span>
            ))}
          </div>
        </section>

        {/* Freeware notice */}
        <section className="rounded-xl bg-surface-light p-8 text-center flex flex-col items-center gap-4">
          <h2 className="text-xl font-bold text-text">{t('landing.notice.title')}</h2>
          <p className="text-sm text-text-muted max-w-lg leading-relaxed">{t('landing.notice.text')}</p>
          <a
            href="https://www.paypal.com/paypalme/masterlevel"
            target="_blank"
            rel="noopener noreferrer"
            className="rounded-lg border-2 border-surface-lighter px-5 py-2.5 text-sm font-medium text-text-muted transition-colors hover:border-primary hover:text-primary"
          >
            {t('landing.notice.cta')}
          </a>
        </section>

      </div>
    </>
  )
}
